(function () {
  var storageKey = 'synticore.no_package_preview.show_ignored';
  var hideClass = 'no-package-preview--hide-ignored';
  var rootElement = document.querySelector('.no-package-preview');
  var collapseButtonElement = rootElement ? rootElement.querySelector('.example--control-panel__collapse') : null;
  var toggleWrapElement = rootElement ? rootElement.querySelector('.no-package-preview__toggle') : null;
  var toggleElement = rootElement ? rootElement.querySelector('.no-package-preview__input') : null;
  var exampleBannerElement = rootElement ? rootElement.querySelector('.no-package-preview__banner') : null;

  if (!rootElement || !collapseButtonElement || !toggleElement || !toggleWrapElement || !exampleBannerElement) {
    return;
  }

  function refreshStickyLayout() {
    document.dispatchEvent(new CustomEvent('refreshStickyLayout'));
    window.dispatchEvent(new Event('scroll'));
  }

  function updateState(showIgnored) {
    document.documentElement.classList.toggle(hideClass, !showIgnored);
    toggleElement.checked = showIgnored;

    try {
      window.localStorage.setItem(storageKey, showIgnored ? '1' : '0');
    } catch (error) {
      // Ignore storage failures, e.g. private mode restrictions.
    }

    refreshStickyLayout();
  }

  function updateCollapseButtonState() {
    var isCollapsed = rootElement.classList.contains('example--control-panel--collapsed');
    collapseButtonElement.textContent = isCollapsed ? 'Expand' : 'Collapse';
    collapseButtonElement.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
  }

  collapseButtonElement.addEventListener('click', function () {
    rootElement.classList.toggle('example--control-panel--collapsed');
    updateCollapseButtonState();
    refreshStickyLayout();
  });

  updateCollapseButtonState();

  var pathname = window.location.pathname || '';
  var isExamplePage = /^\/example(?:\/|$)/.test(pathname);

  if (isExamplePage) {
    // Example pages are package-ignored by path, so keep all content visible and hide the toggle UI.
    document.documentElement.classList.remove(hideClass);
    toggleWrapElement.hidden = true;
    exampleBannerElement.hidden = false;
    refreshStickyLayout();
    return;
  }

  var storedValue = null;
  try {
    storedValue = window.localStorage.getItem(storageKey);
  } catch (error) {
    storedValue = null;
  }

  updateState(storedValue !== '0');

  toggleElement.addEventListener('change', function () {
    updateState(toggleElement.checked);
  });
})();
